import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
//import { Router } from "@angular/router";
import { SharedService } from "src/app/shared/shared.service";
import { PAGE_VIEW_TYPE } from "src/app/utility/Constants";
import { FormControl } from "@angular/forms";
import { debounceTime, distinctUntilChanged, startWith, combineLatest, Subscription, switchMap, map } from "rxjs";
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: "app-material-return-to-godown-list",
  templateUrl: "./material-return-to-godown-list.component.html",
  styleUrls: ["./material-return-to-godown-list.component.scss"],
})
export class MaterialReturnToGodownListComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  isLoading = false;
  displayedColumns = ["position", "action", "returnNo", "siteName", "godownName", "status"];
  dataSource = new MatTableDataSource<any>([]);

  availableColumns = [
  { value: "position", viewValue: "Sr No", selected: true },
  { value: "action", viewValue: "Action", selected: true },
  { value: "returnNo", viewValue: "Return No", selected: true },
  { value: "siteName", viewValue: "Site", selected: true },
  { value: "godownName", viewValue: "To Godown", selected: true },
  { value: "status", viewValue: "Status", selected: true },
];

selectAllColumns = true;

  totalData: number = 0;
  
  // Controls for Searching and Filtering
  searchControl = new FormControl('');
  siteFilterControl = new FormControl('');
  godownFilterControl = new FormControl('');

  siteList: any[] = [];
  godownList: any[] = [];
  
  siteSearchCtrl = new FormControl('');
  godownSearchCtrl = new FormControl('');
  filteredSites: any[] = [];
  filteredGodowns: any[] = [];

  private subscriptions = new Subscription();

  constructor(private _router: Router, public SharedService: SharedService) {}
  

  ngOnInit(): void {
    this.fetchDropdowns();
  }
onEdit(element: any) {
    this._router.navigate(['/materialReturn/materialReturnToGodown/edit', element.matReturnGodownKey], { 
      queryParams: { viewType: PAGE_VIEW_TYPE.UPDATE } 
    });
  }

  onView(element: any) {
    this._router.navigate(['/materialReturn/materialReturnToGodown/edit', element.matReturnGodownKey], { 
      queryParams: { viewType: PAGE_VIEW_TYPE.VIEW } 
    });
  }

  ngAfterViewInit() {
    Promise.resolve().then(() => {
      if (!this.paginator) {
        console.error('Paginator not initialized');
        return;
      }
      this.setupPaginationAndSearch();
    });
  }

 fetchDropdowns() {
    this.SharedService.getSites().subscribe((res: any) => {
      console.log("🔥 SITES API RESPONSE:", res); // ADD THIS
      this.siteList = res?.data || res || [];
      this.filteredSites = [...this.siteList]; 
    });

    this.SharedService.getGodowns().subscribe((res: any) => {
      console.log("🔥 GODOWNS API RESPONSE:", res); // ADD THIS
      this.godownList = res?.data || res || [];
      this.filteredGodowns = [...this.godownList]; 
    });
  }

  setupPaginationAndSearch() {
    const search$ = this.searchControl.valueChanges.pipe(startWith(''), debounceTime(500), distinctUntilChanged());
    const siteFilter$ = this.siteFilterControl.valueChanges.pipe(startWith(''));
    const godownFilter$ = this.godownFilterControl.valueChanges.pipe(startWith(''));
    const page$ = this.paginator.page.pipe(startWith({ pageIndex: 0 }));

    const combined$ = combineLatest([page$, search$, siteFilter$, godownFilter$]).pipe(
      switchMap(([pageEvent, searchText, siteId, godownId]) => {
        const pageIndex = (pageEvent as any).pageIndex ?? 0;
        
        return this.SharedService.getAllMaterialReturnToGodownByPageCount({
          page: pageIndex,
          searchText: searchText || '',
          siteId: siteId || null,
          godownId: godownId || null
        });
      }),
      map((res: any) => {
        this.totalData = res?.totalData || 0;
        return res?.data || [];
      })
    );

    this.subscriptions.add(combined$.subscribe((data) => {
      this.dataSource.data = data;
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  // onView(item: any) {
  //   this._router.navigate([`materialReturn/godown/view/${item}`], { queryParams: { viewType: PAGE_VIEW_TYPE.VIEW } });
  // }

  // onEdit(item: any) {
  //   this._router.navigate([`materialReturn/godown/edit/${item}`], { queryParams: { viewType: PAGE_VIEW_TYPE.UPDATE } });
  // }

 

 navigateToAddPage() {
    // Ensure this matches your app's route path for adding a godown return
    this._router.navigate([`materialReturn/materialReturnToGodown/add`], { 
      queryParams: { viewType: PAGE_VIEW_TYPE.ADD } 
    });
  }

  toggleAllColumns(checked: boolean): void {
  this.selectAllColumns = checked;

  this.availableColumns.forEach(column => {
    column.selected = checked;
  });

  this.updateDisplayedColumns();
}

toggleColumn(column: any, checked: boolean): void {
  column.selected = checked;

  this.updateDisplayedColumns();
}

updateDisplayedColumns(): void {

  this.displayedColumns = this.availableColumns
    .filter(column => column.selected)
    .map(column => column.value);

  this.selectAllColumns =
    this.availableColumns.every(column => column.selected);
}

  numbersFun(index: number): number {
    if (this.paginator) {
      return index + 1 + this.paginator.pageIndex * this.paginator.pageSize;
    }
    return index + 1;
  }
}